import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { APP_ROUTING } from './app.routing';
import { PagesModule } from './pages/pages.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthenticationGuard, MsAdalAngular6Module } from 'microsoft-adal-angular6';

export class CustomHammerConfig extends HammerGestureConfig {
  overrides = {
    pinch: { enable: false },
    rotate: { enable: false }
  };
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    APP_ROUTING,
    PagesModule,
    SharedModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      closeButton: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      autoDismiss: true,
      maxOpened: 5,
      countDuplicates: true
    }),
    NgbModule,
    NgxSpinnerModule,

    MsAdalAngular6Module.forRoot({
      tenant: 'f881a2c5-0a89-4831-81b1-c7846c49594d', // inquilino Office 365 tenant
      clientId: '26d0957b-17f8-4119-a222-bf17559a094a', // cliente GUID gotten from the Azure active directory application
      redirectUri: 'http://localhost:4200/titles',
      // redirectUri: 'https://gbi.hachettelivre.mx:8080/titles',
      // redirectUri: 'https://gbi.hachettelivre.mx:8083/titles', //qa
      // redirectUri: 'https://devgbi.hachettelivre.mx:8080/titles', 
      // redirectUri: 'https://devgbi.hachettelivre.mx:8081/titles', //qa 
      cacheLocation: 'localStorage', // enable this for IE, as sessionStorage does not work for localhost.
      navigateToLoginRequestUrl: false,
    }),
  ],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    AuthenticationGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
